import { MapLeafNodes } from "../types/map-leaf-nodes.type";

export function getTypedKeys<T, OutputType = string>(obj: T): MapLeafNodes<T, OutputType> {
  function traverse(current: any, key: string): any {
    if (typeof current !== "object" || current === null || Array.isArray(current)) {
      return key as OutputType;
    }

    const result: any = {};
    for (const key of Object.keys(current)) {
      result[key] = traverse(current[key], key);
    }
    return result;
  }

  return traverse(obj, "");
}
